/** @jsxImportSource @emotion/react */

import type { VideoToolboxChatStyles } from './videoToolboxChatStyles';
import { DEFAULT_VIDEO_TOOLBOX_CHAT_STYLES } from './videoToolboxChatStyles';
import { formatClipStillsCaption } from './videoToolboxClipStillsLib';

export type VideoToolboxThreadIntroProps = {
  clipStillsCount: number;
  styles?: VideoToolboxChatStyles;
};

/** Opening system message for the walkthrough chat thread. */
export const VideoToolboxThreadIntro = ({
  clipStillsCount,
  styles = DEFAULT_VIDEO_TOOLBOX_CHAT_STYLES,
}: VideoToolboxThreadIntroProps) => (
  <div
    css={styles.threadIntro}
    className={'v2g-msg is-kai v2g-say'}
    data-testid={'video-toolbox-chat-thread-intro'}
  >
    <span css={styles.threadIntroCaption} className={'v2g-dim'}>
      {formatClipStillsCaption(clipStillsCount)}
    </span>
    <span css={styles.threadIntroBody}>
      <span css={styles.threadIntroEmphasis}>Type</span>
      {' below or press '}
      <span css={styles.threadIntroEmphasis}>Talk to Text</span>
      {' and walk Kai through the room. '}
      <span css={styles.threadIntroEmphasis}>What you see</span>
      {', '}
      <span css={styles.threadIntroEmphasis}>what it needs</span>
      {' or '}
      <span css={styles.threadIntroEmphasis}>anything to watch for</span>
      {'. Kai scopes each one as you go.'}
    </span>
  </div>
);
